import React from "react";
import "../../styles/sectionPage.css";

/**
 * Shimmering skeleton loader component representing a list/grid of loading product cards.
 */
const ProductSkeleton = () => {
  // Render 4 placeholder skeleton cards
  const skeletons = Array(4).fill(0);

  return (
    <div className="products-grid">
      {skeletons.map((_, index) => (
        <div key={index} className="product-skeleton-card">
          {/* Left / Top Image Frame */}
          <div className="product-skeleton-image skeleton-pulse" />

          {/* Right / Bottom Details Column */}
          <div className="product-skeleton-info">
            <div className="product-skeleton-title skeleton-pulse" />
            <div className="product-skeleton-desc skeleton-pulse" />
            <div className="product-skeleton-desc skeleton-pulse" style={{ width: "70%" }} />
            
            <div className="product-skeleton-meta">
              <div className="product-skeleton-price skeleton-pulse" />
              <div className="product-skeleton-moq skeleton-pulse" />
            </div>
            
            <div className="product-skeleton-button skeleton-pulse" />
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProductSkeleton;
